<section class="page-title" style="background-image: url(assets/images/breadcom.png);">
    <div class="auto-container">
        <div class="content-box">
            <div class="row">
                <div class="col-6">
                    <div class="title">
                        <h1>User</h1>
                    </div>
                </div>
                <div class="col-6">
                    <ul class="bread-crumb clearfix text-right">
                        <li><a routerLink="/">Home</a></li>
                        <li *ngIf="userInfo !== null"><a [routerLink]="['/management/user']">Users List</a></li>
                        <li>{{userId> 0 ? 'Edit User' : 'Add User'}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="formslist">
    <div class="auto-container">
        <div class="content-box">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header" *ngIf="!isFromRegister">
                            {{this.pageInfo.descrip || 'Add/Edit User'}}
                        </div>
                        <div class="card-header" *ngIf="isFromRegister">
                            Register User
                        </div>
                        <div class="card-body">
                            <form [formGroup]="form" (ngSubmit)="submit()">
                                <div class="row">
                                    <div class="col-sm-3" *ngIf="!isFromRegister">
                                        <label for="">Database Id</label>
                                        <input type="text" class="form-control" placeholder="Database Id" value="0"
                                            [value]="createUser.id > 0 ? createUser.id : '0'" disabled>

                                    </div>

                                    <div class="col-sm-3">
                                        <label for="" class="required-text-ted">User Name</label>
                                        <input type="text" maxlength="30" class="form-control"
                                            formControlName="userName" placeholder="User Name">
                                        <div *ngIf="form.controls['userName'].invalid && (form.controls['userName'].dirty|| form.controls['userName'].touched)"
                                            class="col-sm-12 input-fields-wrapper text-red error-message">
                                            <i class="icon-help-circled"></i>
                                            User Name required.
                                        </div>
                                    </div>
                                    <div class="col-sm-3" *ngIf="userId <= 0">
                                        <label for="" class="required-text-ted">Password</label>
                                        <input type="password" maxlength="50" class="form-control"
                                            formControlName="password" placeholder="********">
                                        <div *ngIf="this.form.get('password')?.errors?.['required']  && (form.controls['password'].dirty|| form.controls['password'].touched)"
                                            class="col-sm-12 input-fields-wrapper text-red error-message">
                                            <i class="icon-help-circled"></i>
                                            Password required.
                                        </div>

                                        <div *ngIf="this.form.get('password')?.value?.length > 0 && this.form.get('password')?.errors?.['strong']  && (form.controls['password'].dirty|| form.controls['password'].touched)"
                                            class="col-sm-12 input-fields-wrapper text-red error-message">
                                            <i class="icon-help-circled"></i>
                                            Password should have 12 characters length and atleast one number, one
                                            lowercase and upper case letter and special characters
                                        </div>
                                    </div>

                                    <div class="col-sm-3" *ngIf="!isFromRegister">
                                        <label for="" class="required-text-ted">Level</label>
                                        <select class="form-control" formControlName="level">
                                            <option value="-1">Select Level</option>
                                            <option *ngFor="let item of levels" value="{{item.id}}">{{item.name}}
                                            </option>
                                        </select>
                                        <div *ngIf="form.controls['level'].invalid && (form.controls['level'].dirty || form.controls['level'].touched)"
                                            class="col-sm-12 input-fields-wrapper text-red error-message">
                                            <i class="icon-help-circled"></i>
                                            Level required.
                                        </div>
                                    </div>
                                    <div class="col-sm-3" *ngIf="!isFromRegister">
                                        <label for="" class="required-text-ted">Parent Type</label>
                                        <select class="form-control" formControlName="parentType">
                                            <option value="">Select Parent Type</option>
                                            <option *ngFor="let item of parentTypes" value="{{item?.id}}">{{item?.name}}
                                            </option>
                                        </select>
                                        <div *ngIf="form.controls['parentType'].invalid && (form.controls['parentType'].touched)"
                                            class="col-sm-12 input-fields-wrapper text-red error-message">
                                            <i class="icon-help-circled"></i>
                                            Parent type required.
                                        </div>
                                    </div>
                                    <div class="col-sm-3" *ngIf="form.controls['parentType'].value== 'U'">
                                        <label for="">First Name</label>
                                        <input type="text" maxlength="30" class="form-control"
                                            formControlName="firstName" placeholder="First Name">

                                    </div>

                                    <div class="col-sm-3" *ngIf="form.controls['parentType'].value== 'U'">
                                        <label for="">Last Name</label>
                                        <input type="text" maxlength="30" class="form-control"
                                            formControlName="lastName" placeholder="Last Name">

                                    </div>

                                    <div class="col-sm-3" *ngIf="form.controls['parentType'].value== 'U'">
                                        <label for="">Company</label>
                                        <input type="text" maxlength="100" class="form-control"
                                            formControlName="company" placeholder="Company">

                                    </div>
                                    <div class="col-sm-3" *ngIf="form.controls['parentType'].value== 'U'">
                                        <label for="" class="required-text-ted">UK Postal Code</label>
                                        <input type="text" maxlength="10" class="form-control"
                                            formControlName="postcode" placeholder="Postal Code">
                                        <div *ngIf="this.form.get('postcode')?.errors?.['required']  && (form.controls['postcode'].dirty|| form.controls['postcode'].touched)"
                                            class="col-sm-12 input-fields-wrapper text-red error-message">
                                            <i class="icon-help-circled"></i>
                                            UK Postal Code is required.
                                        </div>
                                        <div *ngIf="this.form.get('postcode')?.errors?.['pattern']  && (form.controls['postcode'].dirty|| form.controls['postcode'].touched)"
                                            class="col-sm-12 input-fields-wrapper text-red error-message">
                                            <i class="icon-help-circled"></i>
                                            UK Postal Code No is not valid.
                                        </div>

                                    </div>
                                    <div class="col-sm-3" *ngIf="form.controls['parentType'].value== 'U'">
                                        <label for="">Telephone No</label>
                                        <input type="text" maxlength="20" class="form-control" formControlName="tel"
                                            placeholder="Telephone">
                                        <div *ngIf="this.form.get('tel')?.errors?.['pattern']  && (form.controls['tel'].dirty|| form.controls['tel'].touched)"
                                            class="col-sm-12 input-fields-wrapper text-red error-message">
                                            <i class="icon-help-circled"></i>
                                            Telephone No is not valid.
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <label for="" class="required-text-ted">Email</label>
                                        <input type="text" maxlength="100" class="form-control" formControlName="email"
                                            placeholder="Email">
                                        <div *ngIf="this.form.get('email')?.errors?.['required']  && (form.controls['email'].dirty|| form.controls['email'].touched)"
                                            class="col-sm-12 input-fields-wrapper text-red error-message">
                                            <i class="icon-help-circled"></i>
                                            Email is required.
                                        </div>

                                        <div *ngIf="this.form.get('email')?.errors?.['pattern']  && (form.controls['email'].dirty|| form.controls['email'].touched)"
                                            class="col-sm-12 input-fields-wrapper text-red error-message">
                                            <i class="icon-help-circled"></i>
                                            Email is not valid.
                                        </div>

                                    </div>

                                    <div class="col-sm-3" *ngIf="form.controls['parentType'].value== 'W'">
                                        <label for="wholesalerId" class="required-text-ted">Wholesaler </label>
                                        <select class="form-control" formControlName="parentId"
                                            placeholder="Wholesaler">
                                            <option value="0">Select Wholesaler</option>
                                            <option *ngFor="let item of wholeSalers" value="{{item.id}}">{{item.name}}
                                            </option>
                                        </select>
                                        <div *ngIf="form.controls['parentId'].invalid && (form.controls['parentId'].dirty|| form.controls['parentId'].touched)"
                                            class="col-sm-12 input-fields-wrapper text-red error-message">
                                            <i class="icon-help-circled"></i>
                                            Wholesaler required.
                                        </div>
                                    </div>

                                    <div class="col-sm-3" *ngIf="form.controls['parentType'].value== 'B'">
                                        <label for="Branch" class="required-text-ted"> Branch </label>
                                        <select class="form-control" formControlName="parentId" placeholder="Branch">
                                            <option value="0">Select Branch</option>
                                            <option *ngFor="let item of branchList" value="{{item.id}}">{{item.name}}
                                            </option>
                                        </select>
                                        <div *ngIf="form.controls['parentId'].invalid && (form.controls['parentId'].dirty|| form.controls['parentId'].touched)"
                                            class="col-sm-12 input-fields-wrapper text-red error-message">
                                            <i class="icon-help-circled"></i>
                                            Branch required.
                                        </div>
                                    </div>

                                    <div class="col-sm-3 rediobtn mt-0">
                                        <p *ngIf="userId > 0">Data Created</p> {{this.createUser.created | date:
                                        'dd/MM/YYYY'}}
                                    </div>
                                    <div class="col-sm-3 rediobtn mt-0">
                                        <p *ngIf="userId > 0">Last Modified</p>{{this.createUser.modified | date:
                                        'dd/MM/YYYY'}}
                                    </div>
                                    <div class="col-sm-3 mt-3 text-right">
                                        <button class="theme-btn style-one">Submit</button>
                                        <button type="button" (click)="reset()"
                                            class="theme-btn style-two">Reset</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<app-loader></app-loader>